
import Vue from 'vue';

export default Vue.extend({
  name: 'HtmlTable',
  props: {
    text: { type: String, required: true },
  },
});
